import { Offer as OfferGraphql, Package } from '@/@types/graphql-types';

export type ClickoutOfferDetails = Pick<
	OfferGraphql,
	'monetizationType' | 'presentationType' | 'retailPriceValue' | 'currency' | 'lastChangeRetailPriceValue'
> & { package: Pick<Package, 'packageId' | 'clearName'> };

export enum ClickoutContentType {
	MainEvent = 'main-event',
	Highlight = 'highlight',
	Interview = 'interview',
	LeavingSoon = 'leaving-soon',
}
